import React, {useState, useEffect} from 'react';
import { Button, StyleSheet, TextInput, View } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Icon from '../../../../components/IcomoonIcon';
import Modal from '../../../../components/Modal';
import BottomSheet from '../../../../components/BottomSheet';
import Input from '../../../../components/Forms/Input';
import { useForm } from 'react-hook-form';
import IconButton from '../../../../components/IconButton';


export default function NewCommentModal({ onRequestClose, visible }) {
  const { control } = useForm();
  
  return (
    <BottomSheet onRequestClose={onRequestClose} visible={visible} height={250}>
      <View style={tw`pt-5 px-5`}>
        <Text style={tw`mb-4 text-lg font-600 text-secondary`}>Comentar</Text>
        
        <View style={tw`mb-0`}>
          <Input control={control} name='name' multiline numberOfLines={5} style={{ subcontainer: tw`rounded-lg`}} />
        </View>
        
        <IconButton title={"Guardar"} style={tw`self-end`} />
      </View>
    </BottomSheet>
  );
}
